
import icon from '../../../../img/slogan.png'
import { ColorPicker } from '../ColorPicker/ColorPicker'
import { useEffect, useState } from 'react'
export function SloganPopup(props) {
    const [isOpenPopup, setIsOpenPopup] = useState(false)
    const [defaultName, setDefaultName] = useState(false)
    const sloganSize =['4','5','6','7','8','9','10']
    const onHandlerUpdateColor = (color) => {
        props.updateChoosedOptions({sloganColor: color})
    }
    const addDefaultSlogan = () => {
        if(defaultName) {
            setDefaultName(false)
            props.updateChoosedOptions({sloganName: ''})
        } else {
            setDefaultName(true)
            props.updateChoosedOptions({sloganName: 'Plate Mate, JE2 3RD'})
        }
    }

    useEffect(() => {
        if(props.choosedOptions.sloganStyle !== 'Open Sans') {
            props.updateChoosedOptions({sloganFont: '6px'})

        }
    }, [props.choosedOptions.sloganStyle])
    return (
        <div className="option-popup__wrapper">
            <div className="option-popup__close" onClick={() => props.closePopup(null)}></div>
            <div className="option-popup__title flex items-center">
                <figure className="option-popup__icon">
                    <img src={icon} alt='size icon' />
                </figure>
                <h4>Slogan</h4>
            </div>
            <p>
            Create your slogan
            </p>
            <div className="option-popup__input-text">
                <label for="slogan">Your Slogan</label>
                <input
                    id="slogan"
                    onChange={(e) => {
                        setDefaultName(false)
                        let val = e.target.value
                        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}]/u;

                        if(!val || !emojiRegex.test(val)) {
                            val = val.replaceAll(/['"]/g, "");
                            props.updateChoosedOptions({sloganName: val})
                        }
                    }}
                    type='text'
                    maxLength={25}
                    value={props.choosedOptions.sloganName.replaceAll(/\\'/g, "'")}
                />
                <div className='radio-buttons flex flex-wrap items-center'>
                    <div className={defaultName === true ? ' switcher switcher--active' : ' switcher' } onClick={addDefaultSlogan} >Enter Defaults </div>
                </div>
            </div>
            <p>Slogan Font Style</p>
            <div className='font-dropdown' onClick={() => setIsOpenPopup(!isOpenPopup)}>
                <div className='font-dropdown__head'>{props.choosedOptions.sloganStyle !== 'null' ? props.choosedOptions.sloganStyle : 'Select Font Style'}</div>
                {isOpenPopup &&
                    <div className='font-dropdown__content'>
                    {props.plateBuilder['font-family'].map((item) => {
                        if (item.slogan) {
                            return (
                                <div className={item.font === props.choosedOptions.sloganStyle ? "font-dropdown__item--active font-dropdown__item" : " font-dropdown__item"} style={{"font-family": item.font}}  onClick={() => props.updateChoosedOptions({ sloganStyle: item.font})}>
                                    <div className="font-dropdown__name">{item.name}</div>
                                </div>
                            )
                        }
                    })}</div>
                }
            </div>
            {props.choosedOptions.sloganStyle === 'Open Sans' &&
            <div className='option-popup__select'>
                        <label for="select3">Slogan Font Size</label>
                        <select id="select3" onChange={(e) => props.updateChoosedOptions({ sloganFont: e.target.value + 'px' })}>
                            <option value="0" disabled selected={props.choosedOptions.sloganFont === '8px'}>Select Font Size</option>
                            {sloganSize.map((item) => {
                                return <option value={item} selected={+item === parseInt(props.choosedOptions.sloganFont)}>{item}</option>
                            })}
                        </select>
                    </div>

            }
            <ColorPicker color={props.choosedOptions.sloganColor} updateColor={onHandlerUpdateColor}></ColorPicker>
            <div className="option-popup__btn flex justify-center"><div className="btn" onClick={() => props.closePopup(null)}>CONTINUE</div></div>

        </div>
    )
}